import { UrlContext } from '@/context/UrlContext';
import { useSessionStorage } from 'usehooks-ts';

export const UrlContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [savedUrl, setSavedUrl] = useSessionStorage<string>('SavedUrl', '');

  return (
    <UrlContext.Provider
      value={{
        savedUrl: savedUrl,
        setSavedUrl: setSavedUrl
      }}
    >
      {children}
    </UrlContext.Provider>
  );
};
